<template>
    <div>
        <div class="container bordered">
            <div class="py-3"><h1>{{$ml.get('CURRENCY_REQUIRED_TITLE')}}</h1></div>
            <p class="py-3" v-if="$ml.current=='tr'">Hesabınızı ilk oluşturduğunuzda <strong>varsayılan para birimini</strong> seçmeniz gerekmektedir.</p>
            <p class="py-3" v-else>You have to choose the <strong>default currency</strong> on a new account.</p>

            <div class="row">
                <div class="pl-5 col-md-1">
                    <i class="fa fa-info-circle fa-4x text-danger"></i>
                </div>
                <div class="col-md-11">
                    <div v-if="$ml.current=='tr'">
                        <p><span class="h3">Önemli Bilgilendirme!</span></p>
                        <p>Varsayılan para birimi;</p>
                        <ul>
                            <li>Fırsatlar modülündeki göstergelerde</li>
                            <li>Detay ekranlarındaki fırsat sekmelerinde</li>
                            <li>Raporlarınızda gösterilecek tutarların hesaplanmasında kullanılır.</li>
                        </ul>
                        <p><strong>Önemli Not:</strong></p>
                        <p>Fırsatınızın varsayılan para birimine göre değeri fırsatın yaşam döngüsünde aşağıdaki 3 durumda hesaplanır:
                        </p>
                        <ul>
                            <li>Fırsatınız oluşturulduğunda</li>
                            <li>Fırsatınızın değeri değiştiğinde</li>
                            <li>Fırsatınız kapandığında (sonuçlandığında)</li>
                        </ul>
                        <p>Örnek olarak varsayılan para biriminiz Türk Lirası. $100 değerinde bir fırsatı 04/02/2021 tarihinde oluşturdunuz.
                            04/02/2021 tarihindeki $ (USD) kuru 7,12 olarak kabul edelim. Bu fırsatın varsayılan para birimindeki karşılığı
                            712 TL'dir.</p>
                        <p>Eğer varsayılan para birimini ileride &euro; (Euro)' ya çevirirseniz, değişiklik tarihinden
                            <strong>sonra</strong> farklı para birimlerinde açılan fırsatların varsayılan değeri Euro'ya göre sorunsuz
                            çevrilmeye devam edecektir.</p>
                        <p>Fakat varsayılan para birimi <strong>değişim tarihinden önce oluşturulmuş (açık/kapalı)</strong> fırsatların
                            değerleri Euro'ya çevrilmeyecektir, değer Euro olarak belirtilecektir.</p>
                        <p><strong>Yukarıdaki bahsi geçen örnekte varsayılan para birimi değişiminden sonra fırsat değeri $100'ın Euro
                                karşılığı olarak değil, &euro;712 olarak gelecektir.</strong><br /><strong>Önceki para birimi olan Türk
                                Lirasında 100 TL olarak açılmış bir fırsat da, yeni para birimi Euro olduğunda &euro;100 olarak
                                gelecektir.</strong></p>
                        <p><strong>Uyarı!</strong></p>
                        <ul>
                            <li>Seçilen varsayılan para birimi <strong>hesabınızdaki tüm kullanıcılar</strong> tarafından kullanılacaktır.
                            </li>
                            <li>Bu kapsamda seçeceğiniz varsayılan para değerinden emin olmanız gerekmektedir.</li>
                            <li>Varsayılan para birimini değiştirdiğinizde yukarıdaki örnekte yer alan durumlar söz konusu olabilir.</li>
                        </ul>
                    </div>
                    <div v-else>
                        <p><span class="h3">Important Information</span></p>
                        <p>The default currency is used below;</p>
                        <ul>
                            <li>The dashboard in the deals module</li>
                            <li>In deal tabs on detail screens</li>
                            <li>In the amounts to be shown in the reports.</li>
                        </ul>
                        <p>The default currency is your base currency. It operates at the company level. Users can create deals in various
                            currencies in Minimum CRM. All deals that are created in other currencies are converted to default currency as an
                            aggregate.&nbsp;</p>
                        <p><strong>Important note:</strong></p>
                        <p>It is important to remember that the deal value in the base currency will be calculated for a deal thrice along the
                            lifecycle of the deal</p>
                        <ul>
                            <li>When the deal is created</li>
                            <li>When the deal&rsquo;s value is changed</li>
                            <li>When the deal is closed (finalized)</li>
                        </ul>
                        <p>For example, consider your default currency is ₺ (Turkish Lira).&nbsp;</p>
                        <p>A deal of $100 in value was created on 04/02/2021. Let's take the $ (USD) exchange rate on 04/02/2021 as ₺ 7,12. So
                            this deal is calculated as ₺712 in the default currency.&nbsp;</p>
                        <p>If after some time you wish to change the default currency to &euro; (Euro), the values of the deals you create
                            <strong>after</strong> the change of the default currency will be converted to Euro with no problems.&nbsp;&nbsp;
                        </p>
                        <p>However, the values of all deals (open/closed) that have been <strong>created <span style="text-decoration: underline;">before</span> the change of the default currency</strong> will
                            <strong>not be</strong> converted to Euro straight away.&nbsp;</p>
                        <p><strong>Consider our previous example where there was a deal with a value of $100. After you change the default
                                currency from Turkish Lira to Euro, the value in the default currency will not be the equivalent of $100 in
                                Euros but simply be taken as &euro;712. Since it is the value according to the previous default
                                currency.</strong></p>
                        <p><strong>Another example is like this. Consider you had opened a deal before the change of the default currency which
                                was Turkish Lira. The value was&nbsp; ₺100. Once you change the default currency to Euro, the value will not be
                                the equivalent of ₺100 in Euros but simply be taken as &euro;100.</strong></p>
                        <p><strong>Warning!</strong></p>
                        <ul>
                            <li>The default currency chosen will be used by all users in your account.</li>
                            <li>In this context, you need to be sure of the default currency you choose.</li>
                            <li>The change of the default currency can cause such incidents described above.</li>
                        </ul>
                    </div>
                    <div class="form-group row d-flex align-items-center pt-3">
                        <label class="col-md-3" for="defCur"><strong>{{$ml.get('DEFAULT_CURRENCY')}}</strong></label>
                        <select class="col-md-1 form-control" v-model.number="currencyId">
                            <option v-for="(cur,index) in currencyData()" v-bind:key="index" :value="cur.id">{{cur.label}}</option>
                        </select>
                    </div>
                    <div class="form-group row">
                        <label for="confirm" class="offset-md-3">
                        <input type="checkbox" v-model="confirm" id="confirm"  class="mr-2">{{$ml.get('CHANGE_CURRENCY_CONFIRM_TEXT')}}
                        </label>
                        <p class="alert-input offset-md-3" v-if="confirmError.state">{{confirmError.message}}</p>
                    </div>
                    <div class="form-group row">
                        <div class="col-md-2 offset-md-3 px-0">
                            <button class="btn bg-new-primary" @click="saveCurrencyF()">{{$ml.get('PROCEED')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import {mapActions,mapState} from 'vuex'
import defineAbilityFor from '../services/rules'
export default {

    name:"defaultCurrencyRequired",
    computed: {
      ...mapState([
          'baseUrl'
      ])
    },
    data() {
        return {
            currencyId:1,
            confirm:false,
            confirmError:{state:false,message:''}
        }
    },
    methods: {
        ...mapActions(['updateCompanySettings']),
        saveCurrencyF(){
            let form = {}
            if(
                !this.confirmValidation()
            ){
                return false
            }
            
            form.currencyId= parseInt(this.currencyId)

            this.updateCompanySettings(form).then((res)=>{return res}).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.data.status.desc 
                    })
                    localStorage.defaultCurrency = this.currencyId
                    this.getPermissionSetF(localStorage.roleId)
                    
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                }
            })
        },
        confirmValidation(){
            this.confirmError.message = ""
            this.confirmError.state = false
            if(!this.confirm){
                this.confirmError.message = this.$ml.get('CONFIRM_TO_PROCEED')
                this.confirmError.state = true
                return false
            }else{
                return true
            }
        },
        getPermissionSetF(userRoleId){
          axios({
                  method:'POST',
                  url:'/getPermissionSet',
                  data:{
                    roleId:userRoleId
                  },
                  baseURL: this.baseUrl,
                    withCredentials:true
                  })
                  .then((res)=>{
                    return res
                  })
                  .then((res)=>{
                    if(res.data.status.code==0){
                      localStorage.loginCookie=true;
                      this.setRules()
                      
                    }else{
                       
                    }
                })
        },
        setRules(){
            try {
              axios({
                method:'GET',
                url:`/getUserPermissions`,
                baseURL: process.env.API_URL,
                withCredentials:true
              }).then((rez)=>{
                var permissions = []
                console.log("res of get user permissions")
                console.log(rez)
                permissions =  rez.data
                localStorage.setItem('rules',JSON.stringify(permissions))
                this.$ability.update(defineAbilityFor(permissions))
                this.$router.push('/deals')
              })
            }catch (err) {
              // Handle Error Here
              console.error(err);
            }
        }
    }
}
</script>
<style>
    @import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");
</style>
